import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { Typography } from 'common/typography';
import { FrontPageOnboarding } from 'modules/front-page';

import { Search } from '../components/Search/Search';
import { useGetEntitiesForUser } from '../components/Search/hooks/useGetEntitiesForUser';
import { Header } from '../components/layout/Header';

const SearchPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SearchBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-inline: 16px;
  gap: 20px;
  margin-block-start: 100px;

  @media (width < ${MOBILE_BREAKPOINT}px) {
    margin-block-start: 52px;
  }
`;

const SearchContainer = styled.div`
  min-width: 600px;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    min-width: 100%;
  }
`;

export const SearchPage = () => {
  const { isLoading, merchants, venues } = useGetEntitiesForUser();

  return (
    <SearchPageContainer>
      <Header />

      <SearchBoxContainer>
        <Typography.Heading1>
          <FormattedMessage id="experience.search.title" />
        </Typography.Heading1>
        <Typography.Body3>
          <FormattedMessage id="experience.search.description" />
        </Typography.Body3>
        {!isLoading && <FrontPageOnboarding merchants={merchants} venues={venues} />}
        <SearchContainer>
          <Search />
        </SearchContainer>
      </SearchBoxContainer>
    </SearchPageContainer>
  );
};
